import { Record } from 'immutable';
const TicketOwner = Record({
  id: 0,
  email: '',
  isCurrentUser: false,
  name: ''
}, 'TicketOwner');
TicketOwner.fromJS = obj => new TicketOwner(Object.assign({}, obj));
export default TicketOwner;